import { guestSelectors } from '@store/guest/selectors';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { multiRoomRateBookingFormConfig } from '../../shared';
import { MultiRoomGuestDetailsStep } from './MultiRoomGuestDetailsStep';
import { validateGuests } from './helpers/validateMultiRoomGuests.helpers';

const selector = formValueSelector(multiRoomRateBookingFormConfig.form);

const mapStateToProps = (state) => ({
  selectedGuests: selector(state, 'guests'),
  loggedGuest: guestSelectors.getGuest(state),
  note: selector(state, 'note'),
});

const MultiRoomGuestDetailsStepForm = reduxForm({
  ...multiRoomRateBookingFormConfig,
  enableReinitialize: true,
  validate: validateGuests as any,
})(MultiRoomGuestDetailsStep as any);

export const MultiRoomGuestDetailsStepContainer: any = connect(mapStateToProps)(
  MultiRoomGuestDetailsStepForm
);
